export default "__VITE_ASSET__CZpHF71h__"